import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { TranslationContext } from '../../contexts/TranslationContext';


export function OrderConfirmationModal(props: {
    onClose: () => void,
    orderNumber: string
}) {


    const tc = useContext(TranslationContext);

    return (
        <Modal onHide={props.onClose}
            animation={false}
            show centered scrollable
        >
            <Modal.Header
                closeButton
                closeLabel={tc.translator("modal close label", "Luk")}>

                <Modal.Title>
                    {tc.translator("order-confirm modal header", "Tilbud oprettet!")}
                </Modal.Title>

            </Modal.Header>


            <Modal.Body>
                <div style={{ whiteSpace: "pre-line" }} className="alert alert-success">
                    {tc.translator("order-confirm modal body-1",
                        "Din løsning har fået tilbudsnummer {number}.",
                        { number: props.orderNumber }
                    )}
                </div>

                <div className="alert alert-warning" style={{marginTop: "1em"}}>
                    {tc.translator("order-confirm modal body-2",
                        "OBS: Dette er IKKE en ordre endnu - indsend tilbudsnummeret til ordrekontoret."
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button onClick={props.onClose} className="btn btn-primary" autoFocus>
                    {tc.translator("order-confirm modal btn ok", "OK")}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
